export default __webpack_public_path__ + "static/documentary-a5fde97790c1b27445baad84bde41923.mp4";